import stepForm from "./stepForm";
import htmlblock from "./htmlblock";
import inputblock from "./inputblock";
import numberblock from "./numberblock";
import selectblock from "./selectblock";
import standardblock from "./standardblock";
import fileblock from "./fileblock";
import unitForm from "./unitForm";
import Agreements from "./agreements";
import Steps from "./steps";
import courseForm from "./courseForm";

export default {
  stepForm,
  htmlblock,
  inputblock,
  numberblock,
  selectblock,
  standardblock,
  fileblock,
  unitForm,
  Agreements,
  Steps,
  courseForm
};
